import React from 'react';
import { m } from 'motion/react';
import { useSeoHead } from '../hooks/useSeoHead';
import { getRoutePair, hreflangFor, SITE_URL } from '../seoRoutes';

const PAIR = getRoutePair('imprint');

const Imprint = () => {
  useSeoHead({
    title: PAIR.en.title,
    description: PAIR.en.description,
    canonical: `${SITE_URL}${PAIR.en.path}`,
    indexable: PAIR.indexable,
    htmlLang: 'en',
    hreflang: hreflangFor(PAIR),
  });

  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="container mx-auto px-6 max-w-4xl">
        <m.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-5xl font-display font-bold mb-8 text-pstax-navy">Imprint</h1>
          
          <div className="grid md:grid-cols-2 gap-12 text-pstax-gray leading-relaxed">
            <div className="space-y-8">
              <section>
                <h2 className="text-[10px] font-black uppercase tracking-[0.2em] text-pstax-blue mb-2">Media owner and publisher</h2>
                <p className="text-lg font-bold text-pstax-navy">PSTax Steuerberatung FlexCo</p>
              </section>

              <section>
                <h2 className="text-[10px] font-black uppercase tracking-[0.2em] text-pstax-blue mb-2">Address</h2>
                <p>Biberhaufenweg 78/19</p>
                <p>1220 Vienna, Austria</p>
              </section>

              <section>
                <h2 className="text-[10px] font-black uppercase tracking-[0.2em] text-pstax-blue mb-2">Contact</h2>
                <p>Email: <a href="mailto:office@pstax.at" className="text-pstax-navy font-bold hover:text-pstax-blue transition-colors">office@pstax.at</a></p>
                <p>Web: <a href="https://pstax.at" className="text-pstax-navy font-bold hover:text-pstax-blue transition-colors">pstax.at</a></p>
              </section>
            </div>

            <div className="space-y-8">
              <section>
                <h2 className="text-[10px] font-black uppercase tracking-[0.2em] text-pstax-blue mb-2">Information according to legal requirements</h2>
                <p className="mb-2"><strong>Company headquarters:</strong> Vienna</p>
                <p className="mb-2"><strong>Object of the company:</strong> Tax consultancy</p>
                <p className="mb-2"><strong>Legal form:</strong> Flexible Kapitalgesellschaft (FlexCo)</p>
                <p className="mb-2"><strong>Commercial register number:</strong> FN 634911 v</p>
                <p className="mb-2"><strong>Commercial register court:</strong> Commercial Court Vienna (Handelsgericht Wien)</p>
                <p className="mb-2"><strong>VAT identification number:</strong> ATU81086478</p>
                <p className="mb-2"><strong>Managing director:</strong> Pascal Schraml</p>
              </section>

              <section>
                <h2 className="text-[10px] font-black uppercase tracking-[0.2em] text-pstax-blue mb-2">Professional affiliation</h2>
                <p className="mb-2"><strong>Professional title:</strong> Steuerberater (Tax Advisor), granted in Austria</p>
                <p>Chamber of Tax Consultants and Auditors (KSW)</p>
                <p>Am Belvedere 10 / Top 4, 1100 Vienna</p>
                <p className="mt-2 text-xs">WT code: 241511</p>
              </section>
            </div>
          </div>

          <div className="mt-16 p-8 bg-pstax-bg rounded-3xl border border-pstax-border">
            <h2 className="text-xl font-display font-bold text-pstax-navy mb-4">Disclaimer</h2>
            <p className="text-sm text-pstax-gray leading-relaxed italic">
              The information provided on this website is for general informational purposes only and does not constitute professional tax or legal advice. While we strive to keep the information up to date and correct, we make no representations or warranties of any kind about the completeness, accuracy, or suitability of the website content. Any reliance you place on such information is therefore strictly at your own risk.
            </p>
          </div>
        </m.div>
      </div>
    </div>
  );
};

export default Imprint;
